/**
 * @flow
 */

import styled, { css } from 'styled-components'
import { lighten, darken, rgba } from 'polished'
import { colors } from '../theme'
import { withTenant } from '../../context/tenantConfig'

const PrimaryButton = styled.button`
  width: 125px;
  height: 45px;
  margin: 0;
  padding: 0;
  background: linear-gradient(
    40deg,
    ${props => darken(0.3, props.tenant.config.theme.primary)},
    ${props => props.tenant.config.theme.primary}
  );
  color: white;
  border-radius: 100px;
  border: 1px solid ${props => darken(0.1, props.tenant.config.theme.primary)};
  box-shadow: 0 0 0 0 ${props => rgba(props.tenant.config.theme.primary, 0.7)};
  transition: all 0.4s ease;
  text-transform: uppercase;
  letter-spacing: 2px;

  ${props =>
    props.hideOnDesktop &&
    css`
      height: 35px;

      @media screen and (min-width: 850px) {
        display: none;
      }
    `} &:hover {
    background: linear-gradient(
      40deg,
      ${props => darken(0.4, props.tenant.config.theme.primary)},
      ${props => props.tenant.config.theme.primary}
    );
    animation: none;
    cursor: pointer;
  }

  &:active {
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 40px rgba(0, 0, 0, 0.16);
    border-color: ${props => lighten(0.15, props.tenant.config.theme.primary)};
    color: ${props => lighten(0.15, props.tenant.config.theme.primary)};
  }

  &:focus {
    outline: none;
  }
`

export default withTenant(PrimaryButton)
